export const ReconnoiterRouting = [
  {
    path: "/project/reconnoiter/list",
    name: "project-reconnoiter-list",
    meta: { title: "勘察记录" },
    component: () =>
      import(
        /* webpackChunkName: "project-reconnoiter" */ "@/views/project/reconnoiter/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/reconnoiter/create",
    name: "project-reconnoiter-create",
    meta: { title: "新增勘察记录", comName: "ProjectReconnoiterFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "project-reconnoiter" */ "@/views/project/reconnoiter/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/reconnoiter/edit/:id",
    name: "project-reconnoiter-edit",
    meta: { title: "编辑勘察记录", comName: "ProjectReconnoiterFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "project-reconnoiter" */ "@/views/project/reconnoiter/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/reconnoiter/detail/:id",
    name: "project-reconnoiter-detail",
    meta: { title: "勘察记录详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-reconnoiter" */ "@/views/project/reconnoiter/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/reconnoiter/flowPrint/:id",
    name: "project-flowPrint-detail",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-reconnoiter" */ "@/views/project/reconnoiter/flow-print/index.vue"
      ),
  },
];
